export const FLAG_GETTING_DISTRICT_POSTAL_CODES =
  'FLAG_GETTING_DISTRICT_POSTAL_CODES';
export const GET_DISTRICT_POSTAL_CODES = 'GET_DISTRICT_POSTAL_CODES';
export const CLEAR_DISTRICT_POSTAL_CODES = 'CLEAR_DISTRICT_POSTAL_CODES';
